module.exports = __webpack_public_path__ + "static/media/Rainfall_Impatient.8848372b.gif";